module.exports = __webpack_public_path__ + "static/image 122-45766124882e10fd103bfc4988a6ebbb.jpg";